import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
const ProposalV2ReactContext = /*#__PURE__*/ createContext(null);
export function ProposalV2Provider({ children, storageKey }) {
    const [restored] = useState(()=>{
        if (storageKey) {
            try {
                const saved = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null');
                if (typeof saved?.id === 'string' && /^[0-9a-f-]{36}$/i.test(saved.id)) {
                    return {
                        id: saved.id,
                        started: saved.started === true
                    };
                }
            } catch  {
            /* A stale locator starts a new conversation. */ }
        }
        return {
            id: crypto.randomUUID(),
            started: false
        };
    });
    const [aiContext, setAiContext] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [activeChatId, setActiveChatId] = useState(restored.id);
    const [conversationStarted, setConversationStarted] = useState(restored.started);
    useEffect(()=>{
        if (storageKey) sessionStorage.setItem(storageKey, JSON.stringify({
            id: activeChatId,
            started: conversationStarted
        }));
    }, [
        storageKey,
        activeChatId,
        conversationStarted
    ]);
    const toggleSidebar = useCallback(()=>setSidebarOpen((v)=>!v), []);
    const value = useMemo(()=>({
            aiContext,
            setAiContext,
            sidebarOpen,
            setSidebarOpen,
            toggleSidebar,
            activeChatId,
            setActiveChatId,
            conversationStarted,
            setConversationStarted
        }), [
        aiContext,
        sidebarOpen,
        toggleSidebar,
        activeChatId,
        conversationStarted
    ]);
    return /*#__PURE__*/ _jsx(ProposalV2ReactContext.Provider, {
        value: value,
        children: children
    });
}
export function useProposalV2Context() {
    const ctx = useContext(ProposalV2ReactContext);
    if (!ctx) {
        throw new Error('useProposalV2Context must be used inside <ProposalV2Provider>');
    }
    return ctx;
}
